
import { namespace } from "vuex-class";
const common_base = namespace("common_base");
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class ComFlagSelect extends Vue {
  @Prop({ type: String, default: "customer" }) // customer supplier_goods_scope supplier_business_scope
  flagType: string;
  @common_base.Action queryCustomerFlagList;
  @common_base.Action saveCustomerFlag;
  @common_base.Action commonLabelItemSave;
  @common_base.Action commonLabelItemQuery;
  flagList: any = [];
  created() {
    this.init();
  }
  // allFlagList:any=[]
  init() {
    let queryFunc;
    let params;
    if (this.flagType === "customer") {
      queryFunc = this.queryCustomerFlagList;
      params = {};
    } else if (this.flagType === "supplier_goods_scope") {
      queryFunc = this.commonLabelItemQuery;
      params = {
        labelClass: "supplier_operating_goods"
      };
    } else if (this.flagType === "supplier_business_scope") {
      queryFunc = this.commonLabelItemQuery;
      params = {
        labelClass: "supplier_business_scope"
      };
    }
    queryFunc(params).then(data => {
      this.flagList = data.data.list;
      this.filterList = data.data.list;
    });
  }
  filterList: any = [];
  handleFilterFlag(val) {
    console.log(val);
    let add = [];
    if (
      val &&
      !this.flagList.some(item => {
        return item.labelDesc === val;
      })
    ) {
      add.push({
        labelDesc: `${val}`
      });
    }
    this.filterList = add.concat(
      this.flagList.filter(item => {
        return item.labelDesc.includes(val);
      })
    );
  }
  handleFlagChange(val) {
    let saveFunc;
    if (this.flagType === "customer") {
      saveFunc = this.saveCustomerFlag;
    } else if (this.flagType === "supplier_goods_scope") {
      saveFunc = this.commonLabelItemSave;
    } else if (this.flagType === "supplier_business_scope") {
      saveFunc = this.commonLabelItemSave;
    }
    val.forEach(item => {
      if (this.flagList.every(flagObj => flagObj.labelDesc !== item)) {
        saveFunc({
          ...(this.flagType === "supplier_goods_scope" ? { labelClass: "supplier_operating_goods" } : {}),
          ...(this.flagType === "supplier_business_scope" ? { labelClass: "supplier_business_scope" } : {}),
          labelDesc: item
        }).then(() => {
          this.init();
        });
      }
    });
  }
}
